function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M226.8 113.3l56.7-70.8H250L262.2 0l-56.7 70.8h33.4l-12.1 42.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "95.4",
  cy: "237.3",
  r: "10.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "230.2",
  cy: "237.2",
  r: "10.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "162.8",
  cy: "237.3",
  r: "10.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "196.5",
  cy: "237.3",
  r: "10.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "129.1",
  cy: "237.3",
  r: "10.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.2 191.4v-49.6h-42.5v-78h-41.2L140.1 79 69.2 6.2 6.7 95l-.5.8c-11.9 19.8-6 45.3 13.3 57l2.8 1.7c6.2 3.8 13.4 5.8 20.7 5.8 3.6 0 7.2-.5 10.7-1.4 10.6-2.8 19.7-9.6 25.3-19.1L54.6 125c-1.8 3.1-4.8 5.3-8.2 6.2-3.1.9-6.5.4-9.3-1.2l-2.8-1.7c-5.7-3.5-7.4-11.2-3.9-17.5l42.4-60.2 45.9 47.1-26.5 23.1v70.4h-6c-24.1 0-43.6 19.5-43.6 43.6v4.9c0 24.1 19.5 43.6 43.6 43.6h153.7c24.1 0 43.6-19.5 43.6-43.6V235c-.1-23.6-18.8-42.9-42.3-43.6zm-73-99.1h1.9v49.4h-49.4v-7.8l47.5-41.6zm-47.5 77.9l92 .1v21h-92v-21.1zm134.2 69.6c0 8.3-6.8 15.1-15.1 15.1H86.1c-8.3 0-15.1-6.8-15.1-15.1V235c0-8.3 6.8-15.1 15.1-15.1h153.7c8.3 0 15.1 6.8 15.1 15.1v4.8z"
})));